import styled from 'styled-components/macro';
import { Subtitle as BaseSubtitle } from '../../ui/texts';

const Subtitle = styled(BaseSubtitle)`
  font-size: 24px;
`;

export default Subtitle;
